<template lang="pug">
  div(class="slider")
    v-row(no-gutters justify="space-between" class="mb-6")
      h2(class="slider-title") Новостройки
      div(class="slider-nav")
        v-btn(
          @click.prevent="prev"
          small tile icon
          :disabled="pagination.page <= 1 ? true : false" class="btn btn-prev")
          v-icon(small) keyboard_arrow_left
        v-btn(
          @click.prevent="next"
          small tile icon
          :disabled="complexPageCount === pagination.page ? true : false" class="btn btn-next")
          v-icon(small) keyboard_arrow_right
    v-row(justify="space-between")
      v-col(cols="4" v-for="(item, index) in complexAllList", :key="index", class="py-0")
        div(class="slider-card", @click.prevent="viewComplex(item.complexId)")
          v-img(
            height="120",
            class="slider-card-img",
            :src="item.photos[0] === undefined ? require('@/assets/images/noimage.png') : item.photos[0]")
          v-col(class="text-center")
            div(class="slider-card-title") {{ item.name }}
            div(class="slider-card-price") от {{ item.costPerM2 || 0 }} $
            div(class="slider-card-address") {{ item.address }}
</template>

<script>
export default {
  data: () => ({
    pagination: {
      count: 3,
      page: 1
    }
  }),
  computed: {
    complexPageCount() {
      return this.$store.getters.getComplexPageCount(this.pagination.count)
    },
    complexAllList() {
      return this.$store.getters.getComplexList({
        page: this.pagination.page,
        count: this.pagination.count
      })
    }
  },
  created() {
    this.$store.dispatch('GET_ALL_COMPLEX_LIST')
  },
  methods: {
    prev() {
      this.pagination.page = this.pagination.page - 1
    },
    next() {
      this.pagination.page = this.pagination.page + 1
    },
    viewComplex(complexId) {
      this.$store.dispatch('SET_VIEWED_COMPLEX', complexId)
      this.$router.push({ path: `/complex/${complexId}` })
    }
  }
}
</script>

<style lang="scss" scoped>
.slider {
  &-title {
    font-weight: 700;
    font-size: 20px;
    line-height: 27px;
    letter-spacing: -0.522222px;
    color: #292929;
    margin-right: 36px;
  }
  &-nav {
    display: flex;
    justify-content: flex-end;
    .btn {
      border: solid 1px #b4b4b4;
      border-radius: 2px;
      &:focus,
      &:hover {
        color: #fff;
      }
      &:hover {
        .v-icon {
          color: #000;
        }
      }
      &-prev {
        border-right: none;
        border-radius: 2px 0 0 2px;
      }
      &-next {
        border-radius: 0 2px 2px 0;
      }
    }
  }
  &-card {
    border-radius: 6px;
    &:hover {
      cursor: pointer;
      box-shadow: 0 0 20px rgba(61, 90, 254, 0.4);
    }
    &-img {
      border-top-right-radius: 6px;
      border-top-left-radius: 6px;
    }
    &-title {
      font-weight: 600;
      font-size: 16px;
      line-height: 22px;
      letter-spacing: -0.456944px;
      color: #456990;
    }
    &-price {
      font-weight: bold;
      font-size: 16px;
      line-height: 22px;
      letter-spacing: -0.391667px;
      color: #333333;
    }
    &-address {
      font-size: 14px;
      line-height: 19px;
      letter-spacing: -0.326389px;
      color: #333333;
    }
  }
}
</style>
